"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useForceUpdate = void 0;
var react_1 = require("react");
function useForceUpdate() {
    var _a = react_1.useState(0), value = _a[0], setValue = _a[1];
    return function () { return setValue(function (value) { return value + 1; }); };
}
exports.useForceUpdate = useForceUpdate;
//# sourceMappingURL=useForceUpdate.js.map